import { Ref, computed } from 'vue'

interface FieldWatcher<T> {
  field: Ref<T>
  modified: Ref<boolean>
  empty: Ref<boolean>
  $reset: () => void
}

export function useFieldWatcher<T>(inputValue: Ref<T>, originalValue: Ref<T>): FieldWatcher<T> {
  const inp = inputValue
  const ori = originalValue
  function isEmpty(field: any): boolean {
    if (typeof field == 'undefined') return true
    if (field == null) return true
    if (field == '') return true
    return false
  }

  const modified = computed(() => {
    if (isEmpty(inp.value) && isEmpty(ori.value)) return false
    return inp.value != originalValue.value
  })

  const empty = computed(() => isEmpty(inp.value))

  function $reset() {
    inp.value = ori.value
  }

  return {
    field: inputValue,
    modified,
    empty,
    $reset
  }
}

interface FieldWatcherGroup {
  modified: Ref<boolean>
  filledCount: Ref<number>
  totalCount: number
  $reset: () => void
}

export function useFieldWatcherGroup(fieldWatchers: FieldWatcher<any>[]): FieldWatcherGroup {
  const modified = computed(() => {
    for (const fw of fieldWatchers) {
      if (fw.modified.value) {
        return true
      }
    }
    return false
  })
  const filledCount = computed(() => {
    let res = 0
    for (const fw of fieldWatchers) {
      if (!fw.empty.value) {
        res += 1
      }
    }
    return res
  })
  function $reset() {
    for (const fw of fieldWatchers) {
      fw.$reset()
    }
  }
  return {
    modified,
    filledCount,
    totalCount: fieldWatchers.length,
    $reset
  }
}
